import TRANSLATIONS from './json/nl_BE_translations.json'

const TRANSLATIONS_NL_BE = {
  'checkout_shipping.pOBoxWarningText': `${window.appConfig?.pOBoxWarningText}`,
  'shopping_cart_details.hoverToZoom': 'Aanwijzen om te zoomen',
  'shopping_cart_details.tapToZoom': 'Tikken om te zoomen',
  'coupon_code.page_link': 'noOffersPagePresent',
  'order_summary.your_promos' : 'Jouw promotiecodes',
  'shopping_cart_details.editImprint': 'Opdruk aanpassen',
  'shopping_cart_details.clickToZoom': 'Klik om in te zoomen',
  'shopping_cart_details.ships_within_msg': 'Wordt binnen [X] werkdagen verzonden',
  'shopping_cart_details.item_total': 'Totaalbedrag:',
  'shopping_cart_details.each': '[X] per stuk',
  'shopping_cart_details.see_more': 'Zie Meer',
  'shopping_cart_details.see_less': 'Zie Minder',
  'order_confirmation.cartToOrderFailureMessage' : 'Je bestelling wordt zometeen bevestigd.',
  'checkout_payment.paymentErrorTitle': 'Fout bij betalen',
  'checkout_payment.paymentErrorMessage': 'Voer je betaalgegevens opnieuw in. Als het probleem zich blijft voordoen, neem dan voor hulp contact op met onze klantenservice.',
  'checkout_payment.empty_string': '',
  'checkout_payment.credit_debit': 'Creditcard/betaalpas',
  'checkout_payment.card_number': 'Kaartnummer*',
  'checkout_payment.expiration_mm_yy': 'MM/JJ*',
  'checkout_payment.cvv': 'CVV*',
  'checkout_payment.name_on_card': 'Naam op kaart*',
  'checkout_payment.check_cc_try_again': 'Controleer het creditcardnummer en probeer het opnieuw.',
  'checkout_payment.check_date_try_again': 'Controleer de datum en probeer het opnieuw.',
  'checkout_payment.check_code_try_again': 'Controleer de code en probeer het opnieuw.',
  'checkout_payment.enter_holder_name': 'Voer de naam op je kaart in.',
  'checkout_payment.enter_cc_number': 'Voer het creditcardnummer in.',
  'checkout_payment.enter_expiration_date': 'Voer de vervaldatum in.',
  'checkout_payment.enter_cvv': 'Voer de beveiligingscode in.',
  'checkout_payment.paypal_pay_later': 'PayPal Op een later moment betalen',
  'checkout_payment.continue_will_open_paypal_account_msg': 'Als je doorgaat, wordt je naar je PayPal-account doorgestuurd.',
  'checkout_payment.continue_will_open_google_pay_account_msg': 'Als je doorgaat, ga je naar Google Pay.',
  'checkout_payment.paypal': 'PayPal',
  'checkout_payment.pay_by_invoice': 'Betalen op factuur',
  'checkout_payment.buy_now_pay_later_info_msg': 'Bestel nu en betaal later! Je ontvangt de factuur zodra je bestelling is verzonden.',
  'checkout_payment.learn_more': 'Meer info',
  'checkout_payment.payment_due_late_fee_info_msg': 'Bij te late betalingen kunnen er kosten in rekening worden gebracht.',
  'shopping_cart_details.unit': 'stuk',
  'shopping_cart_details.editModalSaving': `Je bespaart`,
  'shopping_cart_details.editModalMin_QtyWarning': `Sorry, dat is minder dan ons minimumaantal. Neem contact met ons op om een kleinere bestelling te plaatsen.`,
  'shopping_cart_details.editModalMax_QtyWarning': `Sorry, dat is meer dan ons maximumaantal. Neem contact met ons op om een grotere bestelling te plaatsen.`,
  'product_details.price':'Prijs',
  'product_details.edit_quantity':'Aantal bewerken',
  'myaccount_order_details.seeDetails': 'Details bekijken',
  'myaccount_order_details.viewOrderDetails': 'Bestelgegevens bekijken',
  'myaccount_order_details.payMyInvoice': 'Mijn factuur betalen',
  'myaccount_order_details.buyItAgain': 'Opnieuw kopen',
  'myaccount_order_details.viewImprint': 'Opdruk bekijken',
  'myaccount_order_details.viewArtwork': 'Afbeelding bekijken',
  'myaccount_order_details.productDetails': 'Productdetails',
  'myaccount_order_details.orders': 'bestellingen',
  'my_account_order_details.shipping_and_billing_addresses': 'Verzend- en factuuradressen',
  'my_account_order_details.log_in_to_view' : 'Log in om te bekijken',
  'error.use_of_old_password': 'Wachtwoord moet verschillen van je vorige vijf wachtwoorden.',
  'order_confirmation.postCheckout_signIn':`Log in voor meer voordelen`,
  'order_confirmation.postCheckout_accountCreation':'Meld je aan voor meer voordelen',
  'order_confirmation.postCheckout_trackOrder':'Track eenvoudig je bestelling',
  'order_confirmation.would_you_like_to':'Meld je aan voor aanbiedingen per telefoon en e-mail van Pens.com en krijg speciale kortingen en gratis proefafdrukken',
  'order_confirmation.sign_up.contact_agreement1':'Ja',
  'order_confirmation.sign_up.contact_agreement2':', ik hou van deals!',
  'order_confirmation.sign_up.contact_disagreement1':'Nee',
  'order_confirmation.sign_up.contact_disagreement2':', bedankt',
  'create_account.title':'Account aanmaken',
  'order_confirmation.sign_in.title':'Log in op je account',
  'order_confirmation.my_acc.title':'Mijn account',
  'order_confirmation.addPassword':'Je hoeft alleen een wachtwoord toe te voegen:',
  'order_confirmation.accountCreated':'Account aangemaakt',
  'myaccount_address_list.shippingAddresses': 'Verzendadressen',
  'myaccount_address_list.billingAddresses': 'Factuuradressen',
  'myaccount_address_list.defaultAddress': 'Standaardadres',
  'myaccount_address_list.setDefault': 'Standaard instellen',
  'myaccount_delete_address.delete_confirmation': 'Bevestiging van verwijdering',
  'myaccount_delete_address.confirmation_message': 'Weet je zeker dat je dit adres wilt verwijderen?',
  'myaccount_delete_address.delete_address': 'Adres verwijderen',
  'myaccount_delete_address.delete': 'Verwijderen',
  'myaccount_error_new_password.complexity':"Een nieuw wachtwoord moet het volgende bevatten: een cijfer, een speciaal teken [!#$%&'*+-/=?^_`{|}~.@], een kleine letter en een hoofdletter.",
  'myaccount_error_confirm_password.complexity':"Een bevestigd wachtwoord moet het volgende bevatten: een cijfer, een speciaal teken [!#$%&'*+-/=?^_`{|}~.@], een kleine letter en een hoofdletter.",
  'myaccount_error_new_password.common_password':'Het nieuwe wachtwoord mag niet hetzelfde zijn als je e-mailadres.',
  'myaccount_error_confirm_password.common_password':'Het bevestigde wachtwoord mag niet hetzelfde zijn als je e-mailadres.',
  'myaccount.change_personal_information.change_password_info' : 'Alle actieve apparaten worden uitgelogd.',
  'validation.password_validation_heading' : 'Het wachtwoord moet het volgende bevatten:',
  'validation.password_validation_uppercase' : 'Een hoofdletter',
  'validation.password_validation_lowercase' : 'Een kleine letter',
  'validation.password_validation_symbol' : 'Een speciaal teken',
  'validation.password_validation_number' : 'Een cijfer',
  'validation.password_validation_length' : 'Minimaal 8 tekens',
  'validation.password_validation_match' : 'Wachtwoorden moeten overeenkomen',
  'validation.password_min_characters': 'Het wachtwoord moet minimaal 8 tekens lang zijn.',
  'myaccount_password_settings.heading' : 'Wachtwoordinstellingen',
  'myaccount_password_settings.newPassword' : 'Nieuw wachtwoord',
  'myaccount_password_settings.confirmPassword' : 'Wachtwoord bevestigen',
  'myaccount_password_settings.updatePassword' : 'Wachtwoord bijwerken',
  'myaccount_password_settings.createPassword' : 'Wachtwoord aanmaken',
  'myaccount_password_settings.use_of_old_password': 'Wachtwoord moet verschillen van je vorige vijf wachtwoorden.',
  'order_details.payment_mode_apple_pay' : 'Apple Pay',
  'order_details.payment_mode_google_pay' : 'Google Pay',
  'order_details.payment_mode_ideal' : 'iDEAL',
  'order_details.payment_mode_bancontact' : 'Bancontact',
  'order_details.payment_mode_klarna' : 'Klarna',
  'dashboard.edit' : 'Bewerken',
  'dashboard.greeting':'Hoi,',
  'myaccount_personal_info.save_changes' : 'Wijzigingen opslaan',
  'myaccount_personal_info.cancel' : 'Annuleren',
  'myaccount_personal_info.name_title' : 'Naam',
  'myaccount_personal_info.password_title' : 'Wachtwoord',
  'myaccount_personal_info.add_name' : 'Naam toevoegen',
  'myaccount_personal_info.edit_name' : 'Naam bewerken',
  'myaccount_personal_info.name_updated' : 'Naam bijgewerkt.',
  'myaccount.something_went_wrong': 'Er is iets misgegaan. Probeer het opnieuw.',
  'checkout.reorder.buy_it_again':'Koop het opnieuw',
  'checkout.reorder.purchased':'Gekocht',
  'checkout.reorder.last_qty':'Laatst besteld aantal',
  'checkout.reorder.ships_within_msg':'Wordt binnen [X] werkdagen verzonden',
  'checkout.reorder.add_to_cart': 'Toevoegen aan winkelwagentje',
  'checkout_payment.klarna_text' : 'Klarna',
  'checkout_payment.klarna_continue_text': 'Als je doorgaat, word je naar je Klarna-account doorgestuurd.',
  'shopping_cart_details.add_accessory': 'Een accessoire toevoegen',
  'shopping_bag.expired_discount_coupon':'De promocode die je hebt ingevoerd, is verlopen. Voer een andere promocode in.',
  'shopping_bag.invalid_discount_coupon':'De promocode die je hebt ingevoerd, is niet geldig. Voer een andere promocode in.',
  'order_summary.oops_error': 'Oeps! Het lijkt erop dat er aan onze kant iets fout is gegaan. Probeer het opnieuw.',
  'order_summary.one_promo_at_a_time': 'Er kan maar één promocode tegelijk worden toegepast.',
  'order_summary.code_applied': 'Code toegepast',
  'order_summary.change_promo': 'Promocode wijzigen',
  'order_summary.your_promo_code': 'Je promocode',
  'order_summary.no_items_eligible': 'De artikelen in je winkelwagentje komen niet in aanmerking voor deze promocode.',
  'shopping_cart_details.add_amount': 'Voeg nog voor [X] toe om gebruik te maken van de aanbieding.',
  'order_details.production_time_begin_msg': '*De productietijd begint zodra de bestelling is bevestigd en eventuele afbeeldingen zijn goedgekeurd',
  'order_details.reorder_tat': 'Opnieuw bestelde producten worden binnen X werkdagen verzonden*',
  'import_charge_title':'Importkosten',
  'import_charge_description': 'Recente importkosten hebben invloed gehad op de prijzen van onze producten. We doen ons best om de impact van prijsverhogingen voor onze klanten te verzachten.',
  'gdpr.heading' : 'Account aangemaakt. Welkom!',
  'gdpr.subheading' : 'Je account is aangemaakt met je e-mailadres:',
  'gdpr.promotion': 'Krijg speciale korting en gratis proefdrukken als je je aanmeldt voor aanbiedingen per e-mail van Pens.com.',
  'gdpr.yesDeal' : 'Ja, ik hou van aanbiedingen',
  'gdpr.noDeal' : 'Nee, bedankt',
  'gdpr.button' : 'Doorgaan',
  'new_activation.head' : 'Check je e-mail!',
  'new_activation.sub_head' : 'Hoi',
  'new_activation.main_body1' : 'Bedankt dat je deelneemt aan Pens.com',
  'new_activation.main_body2' : 'Een activeringslink wordt naar uw geregistreerde e-mailadres verzonden',
  'new_activation.main_body3' : 'U kunt pas inloggen, als uw account is geactiveerd. Klik op de activeringslink om uw account te activeren.',
  'myaccount_personal_info.password_not_set' : 'Er is geen wachtwoord ingesteld voor dit account.',
  'myaccount_personal_info.click_here' : 'Klik hier',
  'myaccount_personal_info.to_reset_password' : 'om een nieuw wachtwoord aan te maken.',
  'myaccount_personal_info.note' : 'Opmerking:  met deze actie word je bij alle actieve sessies uitgelogd.',
  'oos.item_out_of_stock': 'Dit item is momenteel niet op voorraad.',
  'oos.view_similar': 'Bekijk vergelijkbare producten',
  'oos.similar_products': 'Vergelijkbare producten',
  'oos.remove_out_of_stock_items': 'Je moet de items die niet op voorraad zijn helaas uit je winkelwagentje verwijderen.',
  'oos.one_or_more_items_removed_from_cart': 'Een of meer maten van dit item zijn niet op voorraad en zijn verwijderd.',
  'oos.go_back_to_review': 'Ga terug naar je winkelwagentje om het te bekijken',
  'oos.go_back_to_remove': 'Ga terug naar je winkelwagentje om het item te verwijderen',
  'oos.out_of_stock': 'Niet op voorraad',
  'moq.lineItem_warning': 'Het geselecteerde aantal is lager dan het minimum voor dit item.',
  'moq.edit_qantity_link_text': 'Selecteer een nieuw aantal.',
  'moq.cart_level_warning': 'Werk het aantal bij om te kunnen betalen.',
  'moq.go_back_to_cart': 'Terug naar winkelwagentje om nieuw aantal te selecteren',
  ...TRANSLATIONS
};
export default TRANSLATIONS_NL_BE;